import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EncryptDataService } from '../security/encypt-data.service';
import { MatDialog } from '@angular/material/dialog';
import { SocketService } from '../services/socket/socket.service';

@Injectable({
  providedIn: 'root',
})
export class Interceptor implements HttpInterceptor {
  private socketService = inject(SocketService);

  private readonly clientName = 'packageHub';

  constructor(
    private router: Router,
    private securityLocalStorage: EncryptDataService,
    private dialog: MatDialog
  ) {}

  getToken() {
    const storedData = localStorage.getItem('data');

    if (!storedData) return null;

    try {
      const data = JSON.parse(
        this.securityLocalStorage.decryptData(storedData)
      );

      return data?.data?.token || null;
    } catch {
      return null;
    }
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.getToken();

    const headers: Record<string, string> = {
      'vivi-client-name': this.clientName,
    };

    /**
     * Evita forzar Content-Type cuando se mande FormData,
     * porque en uploads el navegador debe poner el boundary automáticamente.
     */
    const isFormData = req.body instanceof FormData;

    if (!isFormData) {
      headers['Content-Type'] = 'application/json';
    }

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const authReq = req.clone({
      setHeaders: headers,
    });

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => this.handleError(error))
    );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 401) {
      this.socketService.disconnect();

      if (!localStorage.getItem('tokenExpiredToastShown')) {
        localStorage.setItem('tokenExpiredToastShown', 'true');
      }

      this.router.navigate(['/auth/login']);
    }

    return throwError(() => error);
  }
}